import React, { Fragment } from "react";
import {
  Box,
  Container,
  Grid,
  Skeleton,
  Paper,
} from "@mui/material";

const BlogDetailsSkeleton = () => (
  <Fragment>
    {/* Hero Section Skeleton */}
    <Box
      sx={{
        position: 'relative',
        height: '60vh',
        width: '100%',
        overflow: 'hidden',
        backgroundColor: '#1A2E55',
      }}
    >
      <Skeleton
        variant="rectangular"
        height="100%"
        animation="wave"
        sx={{
          backgroundColor: '#2B3C5A',
          opacity: 0.7,
          position: 'absolute',
          width: '100%',
        }}
      />
      <Container
        maxWidth="lg"
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 2,
          textAlign: 'center',
          width: '100%',
        }}
      >
        <Skeleton
          variant="text"
          animation="wave"
          sx={{
            fontSize: { xs: '2rem', sm: '3rem', md: '4rem' },
            width: '80%',
            margin: '0 auto',
            backgroundColor: '#2B3C5A',
            opacity: 0.7,
          }}
        />
        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 3 }}>
          <Skeleton
            variant="rounded"
            width={150}
            height={32}
            animation="wave"
            sx={{ backgroundColor: '#2B3C5A', opacity: 0.7 }}
          />
          <Skeleton
            variant="rounded"
            width={150}
            height={32}
            animation="wave"
            sx={{ backgroundColor: '#2B3C5A', opacity: 0.7 }}
          />
        </Box>
      </Container>
    </Box>

    {/* Content Section Skeleton */}
    <Box
      sx={{
        backgroundColor: '#0B0F19',
        minHeight: '100vh',
        py: 8,
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Main Content Skeleton */}
          <Grid item xs={12} md={8}>
            <Paper
              elevation={3}
              sx={{
                backgroundColor: '#1A2E55',
                borderRadius: 2,
                overflow: 'hidden',
                mb: 4,
              }}
            >
              <Box sx={{ p: 4 }}>
                {[...Array(6)].map((_, index) => (
                  <Skeleton
                    key={index}
                    variant="text"
                    animation="wave"
                    sx={{
                      fontSize: '1.1rem',
                      backgroundColor: '#2B3C5A',
                      opacity: 0.7,
                      mb: 1,
                    }}
                  />
                ))}
              </Box>
            </Paper>

            {/* Social Share Section Skeleton */}
            <Paper
              elevation={3}
              sx={{
                backgroundColor: '#1A2E55',
                borderRadius: 2,
                p: 3,
                textAlign: 'center',
              }}
            >
              <Skeleton
                variant="text"
                animation="wave"
                sx={{
                  fontSize: '1.5rem',
                  width: '200px',
                  margin: '0 auto',
                  mb: 2,
                  backgroundColor: '#2B3C5A',
                  opacity: 0.7,
                }}
              />
              <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
                {[...Array(4)].map((_, index) => (
                  <Skeleton
                    key={index}
                    variant="circular"
                    width={40}
                    height={40}
                    animation="wave"
                    sx={{ backgroundColor: '#2B3C5A', opacity: 0.7 }}
                  />
                ))}
              </Box>
            </Paper>
          </Grid>

          {/* Sidebar Skeleton */}
          <Grid item xs={12} md={4}>
            {/* Download Section Skeleton */}
            <Paper
              elevation={3}
              sx={{
                backgroundColor: '#1A2E55',
                borderRadius: 2,
                p: 3,
                mb: 4,
              }}
            >
              <Skeleton
                variant="text"
                animation="wave"
                sx={{
                  fontSize: '1.5rem',
                  width: '80%',
                  mb: 2,
                  backgroundColor: '#2B3C5A',
                  opacity: 0.7,
                }}
              />
              <Skeleton
                variant="rectangular"
                height={48}
                animation="wave"
                sx={{
                  backgroundColor: '#2B3C5A',
                  opacity: 0.7,
                  borderRadius: 1,
                }}
              />
            </Paper>

            {/* Article Information Skeleton */}
            <Paper
              elevation={3}
              sx={{
                backgroundColor: '#1A2E55',
                borderRadius: 2,
                p: 3,
              }}
            >
              <Skeleton
                variant="text"
                animation="wave"
                sx={{
                  fontSize: '1.5rem',
                  width: '80%',
                  mb: 2,
                  backgroundColor: '#2B3C5A',
                  opacity: 0.7,
                }}
              />
              {[...Array(2)].map((_, index) => (
                <Skeleton
                  key={index}
                  variant="text"
                  animation="wave"
                  sx={{
                    fontSize: '1rem',
                    backgroundColor: '#2B3C5A',
                    opacity: 0.7,
                    mb: 1,
                  }}
                />
              ))}
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  </Fragment>
);

export default BlogDetailsSkeleton;
